import { makeStyles } from '@material-ui/core/styles';

const green = 'rgba(59, 192, 114, 1)';
const grayBorder = '1px solid rgba(233, 235, 245, 1)';
const grayText = 'rgba(120, 121, 142, 1)';

const useStyles = makeStyles(() => ({
  /* ===== Base container ===== */
  rootPadding: {
    padding: '24px 24px 24px 24px',
    boxSizing: 'border-box',
  },
  groupCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },

  /* ===== Title + toggle row ===== */
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  titleText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },

  /* ===== Yes/No toggle ===== */
  toggleWrap: {
    width: 89,
    height: 28,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  toggleBtnLeft: {
    width: 45,
    height: 28,
    boxSizing: 'border-box',
    padding: '3px 11px',
    background: '#fff',
    border: grayBorder,
    borderRadius: '4px 0 0 4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  toggleBtnRight: {
    width: 45,
    height: 28,
    boxSizing: 'border-box',
    padding: '3px 11px',
    background: '#fff',
    border: grayBorder,
    borderRadius: '0 4px 4px 0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  toggleActive: {
    background: green,
    border: `1px solid ${green}`,
  },
  toggleLabel: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: grayText,
  },
  toggleLabelActive: {
    color: 'rgba(250, 250, 254, 1)',
  },

  /* ===== Data area ===== */
  dataBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  addBtnRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  addBtn: {
    height: 28,
    width: 95,
    padding: '7px 8px',
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(63, 81, 181, 1)',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #3F51B5',
      boxShadow: 'none',
    },
  },

  /* ===== Modal ===== */
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },

  // Height responsive modal using clamp + vh
  modalPaper: {
    width: 428,
    height: 'clamp(420px, 70vh, 640px)',
    maxHeight: '90vh',
    borderRadius: 8,
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    margin: 'auto',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
  },

  modalHeader: {
    height: 41,
    padding: 10,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    flexShrink: 0,
  },
  modalHeaderTitle: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(33, 33, 33, 1)',
  },

  // Scrollable body so footer remains visible
  modalForm: {
    padding: 16,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
  },

  formItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    padding: 0,
    paddingRight: 8,
    paddingBottom: 5,
    boxSizing: 'border-box',
  },
  formLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(120, 121, 142, 1)',
  },
  formHelper: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(175, 176, 191, 1)',
  },

  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 50,
    boxSizing: 'border-box',
    gap: 10,
    padding: '12px 16px',
    flexShrink: 0,
  },
  modalBtn: {
    height: 28,
    width: 68,
    padding: '12px 16px',
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(63, 81, 181, 1)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #3F51B5',
      boxShadow: 'none',
    },
  },
  modalBtnPrimary: {
    height: 28,
    width: 70,
    padding: '12px 16px',
    backgroundColor: '#3F51B5',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#3F51B5',
      border: '1px solid #3F51B5',
      boxShadow: 'none',
    },
  },

  /* ===== Inputs compatibility for RenderFieldBasedOnType ===== */
  selectField: { height: 32 },
  inputRoot: {
    height: 32,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },

  /* ================== HEIGHT-based responsiveness ================== */

  // Taller screens – allow a bit more height cap
  '@media (min-height:1000px)': {
    modalPaper: { height: 'min(640px, 80vh)' },
  },

  // Medium height screens
  '@media (max-height:900px)': {
    modalPaper: { height: '70vh' },
  },

  // Shorter screens
  '@media (max-height:800px)': {
    modalPaper: { height: '64vh' },
    modalHeader: { height: 38, padding: 10 },
    modalFooter: { height: 48, padding: '10px 14px', gap: 8 },
    modalBtn: { fontSize: 13, lineHeight: '18px', width: 64, padding: '10px 14px' },
    modalBtnPrimary: { fontSize: 13, lineHeight: '18px', width: 68, padding: '10px 14px' },
  },

  // Very short screens
  '@media (max-height:700px)': {
    modalPaper: { height: '60vh', maxHeight: '85vh' },
    modalHeaderTitle: { fontSize: 13, lineHeight: '18px' },
  },

  '@media (max-height:600px)': {
    modalPaper: { height: '56vh', maxHeight: '82vh' },
    modalHeader: { height: 36, padding: '8px 10px' },
    modalFooter: { height: 46 },
    modalBtn: { fontSize: 12 },
    modalBtnPrimary: { fontSize: 12 },
  },

  /* ================== WIDTH-based responsiveness ================== */

  /* ≤1440px */
  '@media (max-width:1440px)': {
    rootPadding: { padding: 22 },
    titleText: { fontSize: 13, lineHeight: '20px' },
    addBtn: { fontSize: 12 },

    modalPaper: { width: 420 },
    modalHeaderTitle: { fontSize: 13, lineHeight: '20px' },
  },

  /* ≤1280px */
  '@media (max-width:1280px)': {
    rootPadding: { padding: 20 },
    titleText: { fontSize: 13, lineHeight: '20px' },

    toggleLabel: { fontSize: 13, lineHeight: '20px' },

    modalPaper: { width: 400 },
    modalHeader: { height: 40, padding: 10 },
    modalHeaderTitle: { fontSize: 13 },

    modalBtn: { fontSize: 13, lineHeight: '18px' },
    modalBtnPrimary: { fontSize: 13, lineHeight: '18px' },
  },

  /* ≤1024px */
  '@media (max-width:1024px)': {
    rootPadding: { padding: 16 },
    groupCol: { gap: 8 },
    titleText: { fontSize: 12, lineHeight: '18px' },

    toggleWrap: { width: 86 },
    toggleBtnLeft: { width: 43, padding: '3px 8px' },
    toggleBtnRight: { width: 43, padding: '3px 8px' },
    toggleLabel: { fontSize: 12, lineHeight: '18px' },

    dataBlock: { gap: 8 },
    addBtn: { height: 28, width: 92, fontSize: 12 },

    modalPaper: { width: 360 },
    modalHeader: { height: 38, padding: 10 },
    modalHeaderTitle: { fontSize: 12, lineHeight: '18px' },
    modalForm: { padding: 14 },
    formItem: { paddingRight: 6, paddingBottom: 4 },
    formLabel: { fontSize: 11, lineHeight: '16px' },
    formHelper: { fontSize: 11, lineHeight: '16px' },
    modalFooter: { gap: 8, padding: '10px 14px', height: 48 },
    modalBtn: { width: 64, fontSize: 12, lineHeight: '18px', padding: '10px 14px' },
    modalBtnPrimary: { width: 68, fontSize: 12, lineHeight: '18px', padding: '10px 14px' },
  },
}));

export default useStyles;
